@let conversation = conversationStore.conversation();

<div class="wrapper display-flex flex-direction-column max-height-full">
  <div class="header display-flex align-items-center flex-shrink-0 pr-16">
    <sb-profile-photo
      [activityStatus]="profile.online_status"
      [photoUrl]="profile.profile_photo_url"
      [route]="`/next/profile/${profile.browse_id}`"
      [showFavoriteBadge]="profile.favorited"
      [size]="'md'"
      (click)="close()"
    />

    <div class="ml-2@r">
      <a
        class="display-flex align-items-center"
        data-cy="viewProfile"
        [routerLink]="['/next/profile', profile.browse_id]"
        (click)="close()"
      >
        <div class="t-6@r font-weight-500 color-void hover:color-ash truncate-ellipsis" data-cy="profile-username">
          {{ profile.username }}
        </div>
        @if (profile.verified) {
          <sb-icon class="color-verified ml-1@r" [name]="'verify'" [secondaryColor]="'white'" [size]="'6'" />
        }
        @if (siteStore.features().top_admirer && profile.bids_rank) {
          <sb-top-admirer-badge class="ml-1@r" [place]="profile.bids_rank" />
        }
      </a>

      <sb-activity-status
        [countryCode]="profile.login_country_code"
        [status]="profile.online_status"
        [withDot]="false"
      />
    </div>
  </div>
  @if (conversation) {
    <sb-conversation-content
      class="min-height-0"
      [conversation]="conversation"
      [readyForPopups]="animationShowFinished()"
    />
  } @else {
    <div
      class="content-skeleton center-flex"
      [class.content-skeleton--ben]="memberService.account.benefactor"
      [class.content-skeleton--dep]="memberService.account.dependent"
    >
      @if (showSpinner$ | async) {
        <sb-spinner />
      }
    </div>
  }
</div>

<ng-template #modalHeaderActions>
  @if (siteStore.features().sa_key_in_messages && profile.can_request_access) {
    <sb-secret-access-button
      class="mr-2"
      [profile]="profile"
      [redirectedFrom]="'messages'"
      [size]="'small'"
      [source]="'message-modal-header'"
      [variant]="'button'"
    />
  }
</ng-template>
